<template>
    <div class="search-nav">
        <ul class="search-nav-list d-flex justify-content-between pl-0">
            <!-- <li class="search-nav-items mt-2" v-if="isTherePlatform">
                <KickstarterLogo v-if="this.filters.platforms.includes('kickstarter')" />
                <IndiegogoLogo v-if="this.filters.platforms.includes('indiegogo')" />
            </li> -->
            <li id="keyword-advanced-search" class="search-nav-items">
                <p class="lab c9o4 mb-0">Keywords</p>
                <p class="lab c6">{{this.filters.keyword}}</p>
            </li>
            <li class="search-nav-items">
                <p class="lab c9o4 mb-0">Tags</p>
                <div class="d-flex">
                    <p class="lab c6 mr-3"
                       v-for="(tag,index) in this.filters.tags"
                       :key="`${tag}-${index}`"
                       :id="`tag-advanced-search-${index}`">
                        {{tag}}
                    </p>
                </div>
            </li>
            <li class="search-nav-items">
                <p class="lab c9o4 mb-0">Category</p>
                <div class="d-flex">
                    <p
                        class="lab c6 mr-2"
                        v-for="(category,index) in this.filters.categories"
                        v-if="category"
                        :key="`${category}-${index}`"
                       :id="`choosed-category-${index}`">
                            {{category}}
                    </p>
                </div>
            </li>
            <li class="search-nav-items">
                <p class="lab c9o4 mb-0">Number Of Backers</p>
                <p id="backers-numbers-range" class="lab c6" v-if="this.filters.backNumRange">{{this.filters.backNumRange.join(' - ')}}</p>
            </li>
            <li class="search-nav-items">
                <p class="lab c9o4 mb-0">Project status</p>
                <div class="d-flex">
                    <p 
                        class="lab c6 mr-2"
                        v-for="(status,index) in this.filters.statuses"
                        v-if="status"
                        id="choosed-status"
                        :key="index">
                            {{status}}
                    </p>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import _ from 'lodash'
import KickstarterLogo from '../../assets/img/cardimg/cardicons/kikstart.svg'
import IndiegogoLogo from '../../assets/img/cardimg/cardicons/go.svg'

export default {
    name: 'Filters',
    props: {
        filters: Object,
    },
    components: {
        KickstarterLogo,
        IndiegogoLogo,
    },
    watch: {
        'filters.platforms': 'getIsTherePlatform',
    },
    data() {
        return {
            isTherePlatform: false,
        }
    },
    methods: {
        getIsTherePlatform: function () {
            this.isTherePlatform = !_.isEmpty(this.filters.platforms)
        }
    }
}
</script>

<style scoped lang="scss">
    div.search-nav {
        margin-top: 42px;

        ul.search-nav-list {
            border-bottom: 1px solid #9b9b9b66;
        }
    }
</style>